'use client';

import { useParams } from 'next/navigation';
import { useState } from 'react';
import useSWR from 'swr';

import { Comment } from '@/shared/types';

import { commentAPI } from '../lib';

const fetcher = (url: string) => fetch(url, { cache: 'no-cache' }).then((res) => res.json());

export default function useComments({ locatedFor }: { locatedFor: 'post' | 'publication' }) {
  const [text, setText] = useState('');
  const { slug } = useParams<{ slug: string }>();

  const { data, mutate, isLoading } = useSWR<{ comments: Comment[] }>(
    commentAPI.getAll(slug, locatedFor),
    fetcher,
    { fallbackData: { comments: [] } }
  );

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (text) {
      await fetch(commentAPI.create(slug, locatedFor), {
        method: 'POST',
        body: JSON.stringify({ text }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      setText('');
      await mutate();
    }
  };

  const onDelete = async (comment: Comment) => {
    await fetch(commentAPI.delete, {
      method: 'DELETE',
      body: JSON.stringify({ comment }),
      headers: {
        'Content-Type': 'application/json'
      }
    });
    await mutate();
  };

  return {
    text,
    setText,
    comments: data?.comments,
    onSubmit,
    onDelete,
    isLoading
  };
}
